import React from 'react';


export default class extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      companyName: '',
      competitorQuery: 'Direct competition for the Dutch company ',
      fullName: '',
      firstName: '',
      firstNameAutoSet: true,
      letter: '',
      xValue: '',
      yValue: '',
      competitorText: '',
      copySuccess: false,
      error: null
    };
  }

  componentDidMount() {
    document.title = "Brief Generator (CTO) - Ghostin";
  }

  handleCompanyChange = (e) => {
    const value = e.target.value;
    this.setState({
      companyName: value,
      competitorQuery: 'Direct competition for the Dutch company ' + value
    });
  }

  copyCompetitorQuery = () => {
    navigator.clipboard.writeText(this.state.competitorQuery).then(() => {
      this.setState({ copySuccess: true });
      setTimeout(() => this.setState({ copySuccess: false }), 2000);
    });
  }

  copyLetter = () => {
    navigator.clipboard.writeText(this.state.letter).then(() => {
      this.setState({ copySuccess: true });
      setTimeout(() => this.setState({ copySuccess: false }), 2000);
    });
  }

  handleFullNameChange = (e) => {
    const value = e.target.value;
    this.setState({ fullName: value });
    if (this.state.firstNameAutoSet) {
      const spaceIndex = value.indexOf(' ');
      if (spaceIndex > 0) {
        this.setState({ firstName: value.substring(0, spaceIndex) });
      } else {
        this.setState({ firstName: value });
      }
    }
  }

  handleFirstNameChange = (e) => {
    this.setState({ firstName: e.target.value, firstNameAutoSet: false });
  }

  handleXChange = (e) => {
    this.setState({ xValue: e.target.value });
  }

  handleYChange = (e) => {
    this.setState({ yValue: e.target.value });
  }

  handleCompetitorTextChange = (e) => {
    this.setState({ competitorText: e.target.value });
  }

  setError = (msg) => {
    this.setState({ error: msg });
    setTimeout(() => this.setState({ error: null }), 3000);
  }

  getAddress = () => {
    const { companyName } = this.state;
    if (!companyName) {
      this.setError('Vul eerst een bedrijfsnaam in.');
      return;
    }
    window.open('https://www.google.com/search?q=' + encodeURIComponent(companyName + ' hoofdkantoor postadres'), '_blank');
  }

  getPhone = () => {
    const { companyName } = this.state;
    if (!companyName) {
      this.setError('Vul eerst een bedrijfsnaam in.');
      return;
    }
    window.open('https://www.google.com/search?q=' + encodeURIComponent(companyName + ' hoofdkantoor telefoonnummer'), '_blank');
  }

  generateLetter = () => {
    const { companyName, fullName, firstName, xValue, yValue, competitorText } = this.state;
    if (!companyName || !fullName || !firstName) {
      this.setError('Vul bedrijfsnaam, volledige naam en voornaam in.');
      return;
    }

    const urlName = fullName
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z]/g, '');
    const X = xValue || '[X]';
    const Y = yValue || 'vrijwel geen persoonlijke of technische inzichten deelt';
    const competitors = competitorText || 'jouw concurrenten';

    const letter = `Hey ${firstName},

Wij hebben sinds een paar weken een connectie op LinkedIn. Het viel me op ${X}, maar dat jouw profiel ${Y}. Dat betekent dat een groot deel van de kennis binnen ${companyName} onzichtbaar blijft, terwijl partijen zoals ${competitors} die expertise veel vaker naar buiten brengen.

Ik had je al een DM gestuurd, maar bedacht me dat jouw inbox waarschijnlijk vol zit met geautomatiseerde salesberichten. Ik benader je liever als echt mens.

Jullie ontwikkelaars lossen waarschijnlijk iedere week complexe problemen op. Toch verdwijnen die oplossingen vrijwel altijd in Teams, GitHub, of interne meetings.

Dat is zonde, niet omdat iedere CTO actief moet zijn op LinkedIn, maar omdat de buitenwereld daardoor nauwelijks ziet hoe jullie technisch denken.

Goede programmeurs kiezen steeds vaker voor teams waarvan ze kunnen leren. En enterprise-klanten willen weten hoe het technische team problemen oplost voordat ze een samenwerking aangaan.

Ik heb daarom een video van 161 seconden opgenomen waarin ik laat zien welke technische kennis waarschijnlijk al binnen ${companyName} aanwezig is, en hoe je die zichtbaar kunt maken zonder extra vergaderingen of een developer één regel extra te laten schrijven.

Ga naar ghostin.nl/${urlName} om de video te bekijken.

Misschien zie ik het verkeerd.

Maar als ik gelijk heb, laat ${companyName} iedere week waardevolle technische kennis verdwijnen die juist vertrouwen zou kunnen opbouwen.`;

    this.setState({ letter: letter });
  }

  render() {
    const { companyName, fullName, firstName, xValue, yValue, competitorText, letter, copySuccess, error } = this.state;

    return (
      <div>

        <div className="full big black">
          <div className="wrap content-block">

            <h1 style={{ marginBottom: '1em' }}>Brief Generator (CTO)</h1>

            {error && (
              <div style={{ position: 'fixed', bottom: '20px', left: '50%', transform: 'translateX(-50%)', zIndex: 9999, background: '#ff4444', color: '#fff', padding: '12px 24px', borderRadius: '8px', fontSize: '1em', boxShadow: '0 4px 12px rgba(0,0,0,0.4)', maxWidth: '500px', textAlign: 'center' }}>
                {error}
              </div>
            )}

            {/* Company Name */}
            <div style={{ marginBottom: '2em' }}>
              <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '.4em' }}>
                Bedrijfsnaam
              </label>
              <input
                type="text"
                value={companyName}
                onChange={this.handleCompanyChange}
                placeholder="Bijv. Coolblue"
                style={{
                  width: '100%', maxWidth: '400px', padding: '10px 14px',
                  fontSize: '1em', borderRadius: '6px', border: '1px solid #444',
                  background: '#222', color: '#fff'
                }}
              />
            </div>

            {/* Action Buttons */}
            <div style={{ marginBottom: '2em', display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              <button
                onClick={this.getAddress}
                className="btn btn-fat btn-if btn-if-fill-gold"
              >
                Bedrijfsadres ophalen
              </button>
              <button
                onClick={this.getPhone}
                className="btn btn-fat btn-if btn-if-fill-gold"
              >
                Telefoonnummer ophalen
              </button>
            </div>

            {/* Competitor copy button */}
            <div style={{ marginBottom: '2em' }}>
              <button
                onClick={this.copyCompetitorQuery}
                className="btn btn-fat btn-if btn-if-fill-gold"
              >
                {copySuccess ? 'Gekopieerd!' : 'Kopieer concurrenten prompt'}
              </button>
            </div>

            {/* Letter variable fields */}
            <div style={{ marginBottom: '2em' }}>
              <div style={{ marginBottom: '1em' }}>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '.2em' }}>
                  Wat valt op aan het profiel? (X)
                </label>
                <small style={{ display: 'block', color: '#888', marginBottom: '.4em' }}>
                  Format: &quot;Het viel me op [X].&quot;
                </small>
                <div style={{ marginBottom: '.5em' }}>
                  {[
                    'dat je een goede profielfoto gebruikt',
                    'dat je al een hele prestatie hebt neergezet door relatief lang bij één bedrijf te blijven',
                  ].map((prompt, i) => (
                    <div key={i}>
                    <div
                      onClick={() => this.setState({ xValue: prompt })}
                      style={{
                        cursor: 'pointer',
                        color: '#aaa',
                        fontSize: '.85em',
                        padding: '4px 0',
                        transition: 'color .15s',
                        display: 'inline-block',
                      }}
                      onMouseEnter={e => e.target.style.color = '#f0c040'}
                      onMouseLeave={e => e.target.style.color = '#aaa'}
                    >
                      &quot;{prompt}&quot;
                    </div>
                    </div>
                  ))}
                </div>
                <input
                  type="text"
                  value={xValue}
                  onChange={this.handleXChange}
                  placeholder="Bijv. dat je een goede profielfoto gebruikt"
                  style={{
                    width: '100%', maxWidth: '500px', padding: '10px 14px',
                    fontSize: '1em', borderRadius: '6px', border: '1px solid #444',
                    background: '#222', color: '#fff'
                  }}
                />
              </div>
              <div style={{ marginBottom: '1em' }}>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '.2em' }}>
                  Wat mist het profiel? (Y)
                </label>
                <small style={{ display: 'block', color: '#888', marginBottom: '.4em' }}>
                  Format: &quot;maar dat jouw profiel [Y].&quot;
                </small>
                <div style={{ marginBottom: '.5em' }}>
                  {[
                    'nog veel complexe vakjargon gebruikt',
                  ].map((prompt, i) => (
                    <div key={i}>
                    <div
                      onClick={() => this.setState({ yValue: prompt })}
                      style={{
                        cursor: 'pointer',
                        color: '#aaa',
                        fontSize: '.85em',
                        padding: '4px 0',
                        transition: 'color .15s',
                        display: 'inline-block',
                      }}
                      onMouseEnter={e => e.target.style.color = '#f0c040'}
                      onMouseLeave={e => e.target.style.color = '#aaa'}
                    >
                      &quot;{prompt}&quot;
                    </div>
                    </div>
                  ))}
                </div>
                <input
                  type="text"
                  value={yValue}
                  onChange={this.handleYChange}
                  placeholder="Fallback: vrijwel geen persoonlijke of technische inzichten deelt"
                  style={{
                    width: '100%', maxWidth: '500px', padding: '10px 14px',
                    fontSize: '1em', borderRadius: '6px', border: '1px solid #444',
                    background: '#222', color: '#fff'
                  }}
                />
              </div>
              <div style={{ marginBottom: '1em' }}>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '.4em' }}>
                  Concurrenten in de brief
                </label>
                <input
                  type="text"
                  value={competitorText}
                  onChange={this.handleCompetitorTextChange}
                  placeholder="Fallback: jouw concurrenten"
                  style={{
                    width: '100%', maxWidth: '500px', padding: '10px 14px',
                    fontSize: '1em', borderRadius: '6px', border: '1px solid #444',
                    background: '#222', color: '#fff'
                  }}
                />
              </div>
            </div>

            {/* Name inputs */}
            <div style={{ marginBottom: '2em', display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
              <div>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '.4em' }}>
                  Volledige naam
                </label>
                <input
                  type="text"
                  value={fullName}
                  onChange={this.handleFullNameChange}
                  placeholder="Bijv. Pieter Zwart"
                  style={{
                    width: '100%', maxWidth: '260px', padding: '10px 14px',
                    fontSize: '1em', borderRadius: '6px', border: '1px solid #444',
                    background: '#222', color: '#fff'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '.4em' }}>
                  Voornaam
                </label>
                <input
                  type="text"
                  value={firstName}
                  onChange={this.handleFirstNameChange}
                  placeholder="Bijv. Pieter"
                  style={{
                    width: '100%', maxWidth: '260px', padding: '10px 14px',
                    fontSize: '1em', borderRadius: '6px', border: '1px solid #444',
                    background: '#222', color: '#fff'
                  }}
                />
              </div>
            </div>

            {/* Generate Letter button */}
            <div style={{ marginBottom: '2em' }}>
              <button
                onClick={this.generateLetter}
                className="btn btn-fat btn-if btn-if-fill-gold"
                style={{ fontSize: '1.1em', padding: '12px 32px' }}
              >
                Genereer Brief
              </button>
            </div>

            {/* Letter output */}
            {letter && (
              <div style={{ marginBottom: '2em' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '.5em' }}>
                  <strong>Gegenereerde brief:</strong>
                  <button
                    onClick={this.copyLetter}
                    className="btn btn-fat btn-if btn-if-fill-gold"
                    style={{ padding: '4px 16px', fontSize: '.85em' }}
                  >
                    {copySuccess ? 'Gekopieerd!' : 'Kopieer brief'}
                  </button>
                </div>
                <pre style={{
                  whiteSpace: 'pre-wrap', wordBreak: 'break-word',
                  background: '#1a1a1a', color: '#e0e0e0', padding: '20px 24px',
                  borderRadius: '8px', fontSize: '.95em', lineHeight: '1.6',
                  maxWidth: '700px', border: '1px solid #333'
                }}>
                  {letter}
                </pre>
              </div>
            )}

          </div>
        </div>

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/LetterGeneratorCTO.js